import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import CheckboxInput from '../../Global/Forms/CheckboxInput';
import Button from '../../Global/Buttons/Button';
import Form from "../../Global/Forms/Form";

const ChangeEmailPreferencesForm = ({
  emailPreferences,
  submitting,
  // Formik props
  values,
  handleChange,
}) => {
  const hasFormChanged = () => {
    if (emailPreferences === values.emailPreferences) {
      return false;
    }
    return true;
  };

  return (
    <Form className="m-b-5">
      <h3 className="like-h3 m-b-3">Email preferences</h3>

      <fieldset className="m-b-5">
        <div className="form-group">
          <CheckboxInput
            name="emailPreferences"
            label="If you wish to receive information about how to use The Coaching Manual as well as news about new content and features, please check this box."
            value="emailPreferences"
            checked={values.emailPreferences}
            onChange={handleChange}
          />
        </div>

        <div className="text-right form-group">
          <Button type="submit" loading={submitting} disabled={hasFormChanged() === false}>Change email preferences</Button>
        </div>
      </fieldset>
    </Form>
  );
};

ChangeEmailPreferencesForm.propTypes = {
  emailPreferences: PropTypes.bool,
  submitting: PropTypes.bool.isRequired,
  // Formik
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const FormikChangeEmailPreferencesForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues({ emailPreferences }) {
    return {
      emailPreferences: emailPreferences || false,
    };
  },
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
  },
})(ChangeEmailPreferencesForm);

export default FormikChangeEmailPreferencesForm;



// WEBPACK FOOTER //
// ./library/app/components/Account/AccountDetails/ChangeEmailPreferencesForm.js